export default {
  maxExpire: 5 * 60 * 1000,
  maxLocalExpire: 120 * 60 * 1000,
  setKey: function(requestData) {
    return JSON.stringify(requestData)
  },
  setValue: function(resp) {
    return JSON.stringify(resp)
  },
  setLocalCache: function(key, value) {
    if (key && value) {
      localStorage.setItem(this.setKey(key), this.setValue({
        resp: value,
        time: new Date().getTime()
      }))
    }
  },
  getLocalCache: function(key) {
    if (key) {
      var cacheData = JSON.parse(localStorage.getItem(this.setKey(key)))
      if (cacheData) {
        var lasttime = cacheData.time
        if (lasttime && !this.isExpireTime(lasttime, this.maxLocalExpire)) {
          return cacheData.resp
        }
      }
    }
    return null
  },
  clearLocalCache: function(key) {
    if (key) {
      // console.log(this.getLocalCache('goldCJToken'),'clear')
      localStorage.removeItem(this.setKey(key));
      // console.log(this.getLocalCache('goldCJToken'),'已经clear');
    }
  },
  isExpireTime: function(lastTime, maxExpire) {
    var current = new Date().getTime()
    if (current - lastTime > maxExpire) {
      return true
    } else {
      return false
    }
  }
}
